import * as React from "react";
function SvgUserEnveloppe(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      ref={svgRef}
      {...props}
    >
      <path
        d="M154.05 182.8l-37.3-18.4a14.19 14.19 0 01-8-12.8V137a49.75 49.75 0 003.3-4.7 74.12 74.12 0 0011.3-23.1 11.16 11.16 0 008-10.9V82.7a10.63 10.63 0 00-3.8-8.5V51.5s4.7-35-42.5-35-42.5 35-42.5 35v22.7a11.28 11.28 0 00-3.8 8.5v15.6a12.9 12.9 0 005.2 9.9 74.74 74.74 0 0014.2 29.3v14.2a13.65 13.65 0 01-7.6 12.3l-34.5 18.9A31.7 31.7 0 000 210.3v12.8h171v-11.8a31.77 31.77 0 00-16.95-28.5z"
        fill="#ffcc10"
      />
      <path
        fill="#70c9f6"
        d="M114.35 173.3v66.2h141.7v-66.2l-72.7-38.7-69 38.7z"
      />
      <path
        fill="#65c1e5"
        d="M256.05 173.3l-72.7-39.2-69 39.2 74.2 30.3 52.4-23.6 15.1-6.7z"
      />
      <path
        fill="#fcfcfc"
        d="M248.95 176.2l-60.4 29.3-65.2-28.4v-4.7h125.6v3.8z"
      />
      <path fill="#65c1e5" d="M256.05 239.5l-68-34.5-73.7 34.5" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgUserEnveloppe);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
